import { ScheduleOrg } from '@wetags/schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useOnlineSchedulingDirectBookingAccess = () => {
  const [isWetagEnabled, isLoadingWetag] = ScheduleOrg.useWetag('online-scheduling-direct-booking');
  const { isScheduleV3FlagEnabled, isLoading: isLoadingV3Flag } =
    SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const isLoading = isLoadingWetag || isLoadingV3Flag;
  const isEnabled = isWetagEnabled && isScheduleV3FlagEnabled;

  return {
    isOnlineSchedulingDirectBookingEnabled: !isLoading && isEnabled,
    isLoading,
  };
};
